import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BulkDocTemplate } from './../../models/bulk-templates';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, DocTemplate, Project } from '../../models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class DocumentTemplateDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getDocumentTemplates(appId: string, projectId: string): Observable<DocTemplate[]> {
        const url = `${this.route}${appId}/projects/${projectId}/doc-templates`;
        return this.httpGet(url);
    }

    getSummaryProjectDocumentTemplates(appId: string, projectId: string): Observable<DocTemplate[]> {
        const url = `${this.route}${appId}/summary-projects/${projectId}/doc-templates`;
        return this.httpGet(url);
    }

    updateDocTemplate(app: App, docTemplate: DocTemplate): Observable<DocTemplate> {
        const url = `${this.route}${app.id}/projects/${docTemplate.projectId}/doc-templates/${docTemplate.id}`;
        return this.httpPut(url, docTemplate);
    }

    createDocTemplate(app: App, docTemplate: DocTemplate): Observable<DocTemplate> {
        const url = `${this.route}${app.id}/projects/${docTemplate.projectId}/doc-templates`;
        return this.httpPost(url, docTemplate);
    }

    deleteDocTemplate(app: App, docTemplate: DocTemplate): Observable<DocTemplate> {
        const url = `${this.route}${app.id}/projects/${docTemplate.projectId}/doc-templates/${docTemplate.id}`;
        return this.httpDelete(url);
    }

    changeActiveDocTemplate(app: App, docTemplate: DocTemplate): Observable<DocTemplate> {
        const url = `${this.route}${app.id}/projects/${docTemplate.projectId}/doc-templates/${docTemplate.id}/activate`;
        return this.httpPut(url, docTemplate);
    }

    postDocTemplateFile(app: App, docTemplate: DocTemplate, isNew: boolean, formData: FormData): Observable<DocTemplate> {
        const url = `${this.route}${app.id}/projects/${docTemplate.projectId}/doc-templates/${docTemplate.id}/file?isNew=${isNew.toString()}`;
        return this.httpPost(url, formData);
    }

    generateDocumentFromTemplate(app: App, project: Project, siteId: string, docTemplateId: string): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/sites/${siteId}/doc-templates/${docTemplateId}`;
        return this.httpDownload(url);
    }

    generateSummaryProjectDocumentFromTemplate(app: App, project: Project, siteId: string, docTemplateId: string): Observable<any> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/sites/${siteId}/doc-templates/${docTemplateId}`;
        return this.httpDownload(url);
    }

    createBulkTemplate(appId: string, bulkTemplate: BulkDocTemplate): Observable<BulkDocTemplate> {
        const url = `${this.route}${appId}/projects/${bulkTemplate.projectId}/doc-templates/bulk-template`;
        return this.httpPost(url, bulkTemplate);
    }

    getBatchDocumentTemplateByProjectId(app: App, project: Project): Observable<BulkDocTemplate[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/doc-templates/bulk-template`;
        return this.httpGet(url);
    }

    processedStatus(app: App, project: Project): Observable<BulkDocTemplate[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/doc-templates/bulk-template/status`;
        return this.httpGet(url);
    }
}
